import { useMutation } from '@tanstack/react-query';
import { META_CONVERSION_API } from '../../consts';
export default function useMetaConversion(props) {
    return useMutation({
        mutationKey: [
            'meta-conversion'
        ],
        mutationFn: async (payload)=>{
            const res = await fetch(META_CONVERSION_API, {
                method: 'POST',
                headers: {
                    accept: 'application/json',
                    'content-type': 'application/json'
                },
                body: JSON.stringify(payload),
                credentials: 'include'
            });
            if (!res.ok) {
                let errorMessage = `Meta CAPI Error (${res.status})`;
                try {
                    const errorData = await res.json();
                    errorMessage = errorData.error || errorMessage;
                } catch  {
                // Response wasn't JSON, use default message
                }
                throw new Error(errorMessage);
            }
            const data = await res.json();
            return data;
        },
        throwOnError: false,
        gcTime: 0,
        retry: false,
        onSuccess: props?.onSuccess,
        onError: props?.onError
    });
}

//# sourceMappingURL=useMetaConversion.js.map